module.exports = __webpack_public_path__ + "static/media/sell_make_2b.8c6557d8.png";